<div class="sidebar-wrapper sidebar-theme">
  <nav id="sidebar">
    <div id="accordionExample">
      <div class="row my-1 text-center ml-1 ml-lg-3 ml-md-3 mr-0 menu1">
        <div class="col-12 pr-md-0">
          <!-- profile badge -->
          <div class="mb-4 white-block">
            <div class="float-right mr-2 mt-1">
              <a href="/profile" class="edit-icon">
                <img src="../../../assets/img/icons/edit.svg" class="width-20" />
              </a>
            </div>
            <div class="pl-5 pr-5 pt-2 pb-3">
              <img class="avatar img-fluid" src="../../../assets/img/user.png" />
              <h5 class="mt-2 mb-1">Bonjour {{ user?.firstName }},</h5>
            </div>
          </div>

          <!-- profile badge -->

          <div *ngIf="user?.userType == 'User'" class="btn-place mt-2 mb-0">
            <a [routerLink]="['/business/livraison/add']" class="btn-orange">Nouvelle livraison

              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="15" viewBox="0 0 24 24" fill="#000000"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="feather feather-plus">
                <line _ngcontent-ckc-c232="" x1="12" y1="5" x2="12" y2="19"></line>
                <line _ngcontent-ckc-c232="" x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
            </a>
          </div>
        </div>

        <ul *ngIf="authService.credentials" class="
            white-block
            list-unstyled
            menu-categories
            mt-3
            ml-lg-3 ml-md-3 ml-0
            mr-lg-0 mr-md-0 mr-3
          ">
          <li *ngIf="authService.credentials?.user?.userType == 'Admin' && 0" class="menu">
            <a [routerLink]="['/groups']" [attr.data-active]="router.url.includes('groups')" class="dropdown-toggle">
              <div class="">
                <span>{{ "GROUPS.TITLE" | translate }}</span>
              </div>
            </a>
          </li>
          <li class="menu" *ngIf="authService.credentials?.user?.userType == 'Admin' && 0">
            <a [routerLink]="['/permissions']" [attr.data-active]="router.url.includes('permissions')"
              class="dropdown-toggle">
              <div class="">
                <span>{{ "PERMISSIONS.TITLE" | translate }}</span>
              </div>
            </a>
          </li>

          <li class="menu" *ngIf="authService.credentials?.user?.userType == 'User'"
            [ngClass]="{ active: router.url == '/business' }">
            <a [routerLink]="['/business']" data-active="false" data-toggle="collapse" aria-expanded="false"
              class="dropdown-toggle collapsed f-light f-15 weight-100 mt-md-0">
              {{ "SIDENAV.DASHBOARD" | translate }}
            </a>
          </li>
          <li [ngClass]="{ active: router.url.includes('support') }" class="menu" *ngIf="user?.userType == 'User'">
            <a [routerLink]="['/support']" data-active="false" data-toggle="collapse" aria-expanded="false"
              class="dropdown-toggle collapsed f-light f-13 weight-100">
              Support
            </a>
          </li>

          <li class="menu" *ngIf="authService.credentials?.user?.userType == 'User'">
            <a href="#pickupsBusiness" data-active="false" data-toggle="collapse" aria-expanded="false"
              class="dropdown-toggle collapsed">
              <div class="f-light f-13 weight-100">Pickups</div>
              <div></div>
            </a>
            <ul class="submenu list-unstyled collapse mb-3" id="pickupsBusiness" data-parent="#accordionExample">
              <li *ngIf="authService.credentials?.user?.services?.includes('2')" [ngClass]="{
                  active:
                    router.url.includes('business/pickups-requests') &&
                    !router.url.includes('statusPickUp=1') &&
                    !router.url.includes('statusPickUp=2')
                }">
                <a [routerLink]="['/business/pickups-requests']" class="weight-100 f-12">
                  Toutes les pickups
                </a>
              </li>
              <li *ngIf="authService.credentials?.user?.services?.includes('2')" [ngClass]="{
                  active: router.url.includes(
                    'business/pickups-requests?statusPickUp=1'
                  )
                }">
                <a [routerLink]="['/business/pickups-requests']" [queryParams]="{ statusPickUp: '1' }"
                  class="weight-100 f-12">
                  En attente d'enlévement
                </a>
              </li>
              <li *ngIf="authService.credentials?.user?.services?.includes('2')" [ngClass]="{
                  active: router.url.includes(
                    'business/pickups-requests?statusPickUp=2'
                  )
                }">
                <a [routerLink]="['/business/pickups-requests']" [queryParams]="{ statusPickUp: '2' }"
                  class="weight-100 f-12">
                  Enlévement en cours
                </a>
              </li>
            </ul>
          </li>

          <li class="menu" *ngIf="authService.credentials?.user?.userType == 'User'">
            <a href="#deliveries" data-active="false" data-toggle="collapse" aria-expanded="false"
              class="dropdown-toggle collapsed">
              <div class="f-light f-13 weight-100">Livraisons</div>
              <div></div>
            </a>
            <ul class="submenu list-unstyled collapse mb-3" id="deliveries" data-parent="#accordionExample">
              <li *ngIf="authService.credentials?.user?.services?.includes('2')" [ngClass]="{
                  active: router.url.includes('business/livraison')
                }">
                <a [routerLink]="['/business/livraison']" class="weight-100 f-12">
                  {{ "SIDENAV.ALL_DELIVERY" | translate }}
                </a>
              </li>

              <li *ngIf="authService.credentials?.user?.services?.includes('2')" [ngClass]="{
                  active:
                    router.url.includes('business/delivered-requests') &&
                    !router.url.includes(
                      'business/delivered-requests?moneySent'
                    )
                }">
                <a [routerLink]="['/business/delivered-requests']" class="weight-100 f-12">
                  {{ "SIDENAV.DELIVERED" | translate }}
                </a>
              </li>
              <li *ngIf="authService.credentials?.user?.services?.includes('2')" [ngClass]="{
                  active: router.url.includes(
                    'business/delivered-requests?moneySent'
                  )
                }">
                <a [routerLink]="['/business/deliveredAndMoneyReceived']" [queryParams]="{ moneySentToClient: '1' }"
                  class="weight-100 f-12">
                  Colis livré et argent reçu
                </a>
              </li>
              <li *ngIf="authService.credentials?.user?.services?.includes('2')" [ngClass]="{
                  active: router.url.includes('business/reported-requests')
                }">
                <a [routerLink]="['/business/reported-requests']" class="weight-100 f-12">
                  {{ "SIDENAV.REPORTED" | translate }}
                </a>
              </li>
              <li *ngIf="authService.credentials?.user?.services?.includes('2')" [ngClass]="{
                  active: router.url.includes('business/return-requests')
                }">
                <a [routerLink]="['/business/return-requests']" class="weight-100 f-12">
                  {{ "SIDENAV.RETURNED" | translate }}
                </a>
              </li>

              <li *ngIf="authService.credentials?.user?.services?.includes('2')" [ngClass]="{
                  active: router.url.includes('business/return-vendor-requests')
                }">
                <a [routerLink]="['/business/return-vendor-requests']" class="weight-100 f-12">
                  {{ "SIDENAV.RETURN_VENDOR" | translate }}
                </a>
              </li>

              <li *ngIf="authService.credentials?.user?.services.includes('1')"
                [ngClass]="{ active: router.url == '/business/conciergerie' }">
                <a [routerLink]="['/business/conciergerie']" class="weight-100 f-12">
                  {{ "SIDENAV.CONCIERGERIE" | translate }}
                </a>
              </li>
              <li *ngIf="authService.credentials?.user?.services.includes('1')" [ngClass]="{
                  active: router.url.includes('conciergerie/historique')
                }">
                <a [routerLink]="['/business/conciergerie/historique']" class="weight-100 f-12">
                  Historique {{ "SIDENAV.CONCIERGERIE" | translate }}
                </a>
              </li>
              <li *ngIf="authService.credentials?.user?.services.includes('3')"
                [ngClass]="{ active: router.url.includes('business/express') }">
                <a [routerLink]="['/business/express']" class="weight-100 f-12">
                  {{ "SIDENAV.EXPRESS_DELIVERY" | translate }}
                </a>
              </li>
            </ul>
          </li>

          <!-- <li [ngClass]="{ active: router.url.includes('blacklist') }" class="menu" [ngClass]="{
              'mb-100': authService.credentials?.user.userType == 'User'
            }">
            <a [routerLink]="['/blackList']" data-active="false" data-toggle="collapse" aria-expanded="false"
              class="dropdown-toggle collapsed f-light f-13 weight-100">
              Clients bannis
            </a>
          </li> -->

          <!--
        <li
          class="menu"
          *ngIf="authService.credentials?.user?.services.includes('1')"
          [ngClass]="{ active: router.url == '/business/conciergerie' }"
        >
          <a
            href="#pickups"
            data-active="false"
            data-toggle="collapse"
            aria-expanded="false"
            class="dropdown-toggle collapsed"
          >
            <div class="f-light f-13 weight-100">
              Pickups
            </div>
            <div>
            </div>
          </a>
          <ul
            class="submenu list-unstyled collapse"
            id="pickups"
            data-parent="#accordionExample"
          >
            <li
              *ngIf="authService.credentials?.user?.services.includes('1')"
              [ngClass]="{ active: router.url == '/business/conciergerie' }"
            >
              <a [routerLink]="['/business/conciergerie']"
                 class="weight-100 f-12"
              >
                {{ "SIDENAV.CONCIERGERIE" | translate }}

              </a>
            </li>
            <li
              *ngIf="authService.credentials?.user?.services.includes('1')"
              [ngClass]="{
              active: router.url.includes('conciergerie/historique')
            }"
            >
              <a [routerLink]="['/business/conciergerie/historique']"
                 class="weight-100 f-12"
              >
                Historique {{ "SIDENAV.CONCIERGERIE" | translate }}
              </a>
            </li>
            <li
              *ngIf="authService.credentials?.user?.services?.includes('2')"
              [ngClass]="{ active: router.url.includes('business/livraison') }"
            >
              <a [routerLink]="['/business/livraison']"
                 class="weight-100 f-12"
              >
                {{ "SIDENAV.DELIVERY" | translate }}
              </a>
            </li>
            <li
              *ngIf="authService.credentials?.user?.services?.includes('2')"
              [ngClass]="{ active: router.url.includes('business/enlevement') }"
            >
              <a [routerLink]="['/business/enlevement']"
                 class="weight-100 f-12"
              >
                Colis en attente d'enlèvement
              </a>
            </li>

            <li
              *ngIf="authService.credentials?.user?.services.includes('3')"
              [ngClass]="{ active: router.url.includes('business/express') }"
            >
              <a [routerLink]="['/business/express']"
                 class="weight-100 f-12"
              >
                {{ "SIDENAV.EXPRESS_DELIVERY" | translate }}
              </a>
            </li>
          </ul>
        </li>



        <li
        >
          <a [routerLink]="['/business/conciergerie']">
            {{ "SIDENAV.CONCIERGERIE" | translate }}
          </a>
        </li>
        <li
          *ngIf="authService.credentials?.user?.services.includes('1')"
          [ngClass]="{
              active: router.url.includes('conciergerie/historique')
            }"
        >
          <a [routerLink]="['/business/conciergerie/historique']">
            Historique {{ "SIDENAV.CONCIERGERIE" | translate }}
          </a>
        </li>
        <li
          *ngIf="authService.credentials?.user?.services?.includes('2')"
          [ngClass]="{ active: router.url.includes('business/livraison') }"
        >
          <a [routerLink]="['/business/livraison']">
            {{ "SIDENAV.DELIVERY" | translate }}
          </a>
        </li>
        <li
          *ngIf="authService.credentials?.user?.services?.includes('2')"
          [ngClass]="{ active: router.url.includes('business/enlevement') }"
        >
          <a [routerLink]="['/business/enlevement']">
            Colis en attente d'enlèvement
          </a>
        </li>

        <li
          *ngIf="authService.credentials?.user?.services.includes('3')"
          [ngClass]="{ active: router.url.includes('business/express') }"
        >
          <a [routerLink]="['/business/express']">
            {{ "SIDENAV.EXPRESS_DELIVERY" | translate }}
          </a>
        </li>

        -->

          <li class="menu" *ngIf="
              authService.credentials?.user?.userType != 'User' &&
              authService.credentials?.user?.services?.includes('2')
            ">
            <a href="#adminDelivery" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
              <div class="">
                <span> {{ "SIDENAV.DELIVERY" | translate }}</span>
              </div>
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="feather feather-chevron-right">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </div>
            </a>
            <ul class="collapse show submenu list-unstyled" id="adminDelivery" data-parent="#accordionExample">
              <li [ngClass]="{ active: router.url.includes('/livraison') &&
                    !router.url.includes('/verification') }"
                *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison']"> Manager</a>
              </li>

              <!-- <li [ngClass]="{ active: router.url.includes('/verification') }"
                *ngIf="authService.credentials?.user?.services?.includes('A-400')">
                <a [routerLink]="['/livraison/verification']"> Vérification </a>
              </li> -->

              <!-- <li
                [ngClass]="{
                  active: router.url.includes('/livraison/responsabilite')
                }"
                *ngIf="authService.credentials?.user?.services?.includes('2')"
              >
                <a [routerLink]="['/livraison/responsabilite']">
                  Responsabilité</a
                >
              </li> -->

              <!-- <li [ngClass]="{
                  active: router.url.includes('livraison/deliveries-groups')
                }" *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/deliveries-groups']">
                  Affectation en groupe
                </a>
              </li> -->

              <li [ngClass]="{
                  active:
                    router.url.includes('livraison/runsheets') &&
                    !router.url.includes('livraison/performanceLivreurs')
                }" *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/runsheets']"> Runsheets </a>
              </li>

              <li [ngClass]="{
                  active:
                    router.url.includes('livraison/runsheet-list') &&
                    !router.url.includes('livraison/performanceLivreurs')
                }" *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/runsheet-list']"> Runsheets liste </a>
              </li>

              <li [ngClass]="{
                  active:
                    router.url.includes('livraison/drivers-order')
                }" *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/drivers-order']"> Rendement Chauffeurs </a>
              </li>

              <!-- <li [ngClass]="{
                  active:
                    router.url.includes('livraison/missed-deliveries') &&
                    !router.url.includes('livraison/performanceLivreurs')
                }" *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/missed-deliveries']"> Colis non calculer </a>
              </li> -->

              <!-- <li [ngClass]="{
                  active: router.url.includes('livraison/performanceLivreurs')
                }" *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/performanceLivreurs']">
                  Performance livreurs
                </a>
              </li> -->

              <!-- <li
              [ngClass]="{
                active: router.url.includes('livraison/acceptedByDate')
              }"
              *ngIf="authService.credentials?.user?.services?.includes('2')"
            >
              <a [routerLink]="['/livraison/acceptedByDate']">
                Historique d'affectation des chauffeurs
              </a>
            </li> -->
              <!-- <li
              [ngClass]="{ active: router.url.includes('unsuccessfulDelivery') }"
              *ngIf="authService.credentials?.user?.services?.includes('2')"
            >
              <a [routerLink]="['/unsuccessfulDelivery']">
                {{ "SIDENAV.FAILED_DELIVERY" | translate }}
              </a>
            </li>-->
              <!-- <li
                [ngClass]="{ active: router.url.includes('stats') }"
                *ngIf="authService.credentials?.user?.services?.includes('2')"
              >
                <a [routerLink]="['/livraison/stats']">
                  Statistiques par date</a
                >
              </li> -->

              <!-- <li [ngClass]="{
                  active: router.url.includes('/manageDelivery/lastSeenDrivers')
                }" *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/manageDelivery/lastSeenDrivers']">
                  Positions des chauffeurs</a>
              </li> -->

              <!-- <li [ngClass]="{'active': router.url.includes('fromMap/dropOff')}">
                          <a [routerLink]="[ '/manageDelivery/fromMap/dropOff' ]"> Livraison - map</a>
                      </li> -->

              <!--
                      <li [ngClass]="{'active': router.url.includes('packagingSlip')}">
                          <a [routerLink]="[ '/packagingSlip' ]"> {{'SIDENAV.REQUESTS' | translate}} </a>
                      </li>
                      -->
            </ul>
          </li>
          <li class="menu" *ngIf="
              authService.credentials?.user?.userType != 'User' &&
              authService.credentials?.user?.services?.includes('2') && 0
            ">
            <a href="#retourAdminSection" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
              <div class="">
                <span> Retour</span>
              </div>
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="feather feather-chevron-right">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </div>
            </a>
            <ul class="collapse submenu list-unstyled" id="retourAdminSection" data-parent="#accordionExample">
              <li [ngClass]="{ active: router.url.includes('/confirmRetour') }"
                *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/confirmRetour']"
                  [queryParams]="{ confirmRetourDefinitif: true, status: 16 }">
                  Vérif retour</a>
              </li>
              <li [ngClass]="{
                  active: router.url.includes('/retourDefinitifConfirmed')
                }" *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/retourDefinitifConfirmed']"
                  [queryParams]="{ retourDefinitifConfirmed: true, status: 16 }">
                  Retour déja vérifié</a>
              </li>

              <li [ngClass]="{
                  active: router.url.includes('clientRequestsRecover')
                }" *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/clientRequestsRecover']"
                  [queryParams]="{ recoverRequestDate: true, status: 16 }">
                  Récupérer</a>
              </li>

              <li [ngClass]="{
                  active: router.url.includes('clientRequestsResend')
                }" *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/clientRequestsResend']"
                  [queryParams]="{ resendRequestDate: true, status: [16, 25] }">
                  Renvoyer</a>
              </li>

              <li [ngClass]="{
                  active: router.url.includes('/livraison/reported')
                }" *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/reported']" [queryParams]="{
                    failureReason: 'Livraison reportée',
                    status: [15, 25]
                  }">
                  livraison reportée</a>
              </li>
            </ul>
          </li>

          <!-- <li class="menu" *ngIf="
              authService.credentials?.user?.userType != 'User' &&
              authService.credentials?.user?.services?.includes('2')
            ">
            <a href="#qualityAdminSection" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
              <div class="">
                <span> Qualité</span>
              </div>
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="feather feather-chevron-right">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </div>
            </a>
            <ul class="collapse submenu list-unstyled" id="qualityAdminSection" data-parent="#accordionExample">
              <li [ngClass]="{ active: router.url.includes('blacklist') }" class="menu">
                <a [routerLink]="['/blackList']" class=""> Clients bannis </a>
              </li>
              <li *ngIf="authService.credentials?.user?.services?.includes('A-700')"
                [ngClass]="{ active: router.url.includes('zone-exeptions') }" class="menu">
                <a [routerLink]="['/zone-exeptions']" class=""> Zones exceptions </a>
              </li>

              <li [ngClass]="{ active: router.url.includes('support') }">
                <a [routerLink]="['/support']"> Support </a>
              </li>
              <li [ngClass]="{
                  active:
                    !router.url.includes('minVal') &&
                    router.url.includes('n/delay')
                }" *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/delay']">Retard Livraison</a>
              </li>
              <li [ngClass]="{ active: router.url.includes('minVal') }"
                *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/delay']" [queryParams]="{
                    status: '25',
                    minVal: '2',
                    failureReasonNotEqual: 'Livraison reportée'
                  }">Retard dans dépôt</a>
              </li>
              <li [ngClass]="{ active: router.url.includes('/livraison/inventory') }">
                <a [routerLink]="['/livraison/inventory']"> Inventaire </a>
              </li>
              <li [ngClass]="{ active: router.url.includes('/livraison/returns') }"
                *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/returns']"> Retour </a>
              </li>
              <li [ngClass]="{ active: router.url.includes('/livraison/relance') }"
                *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/relance']"> Relance </a>
              </li>
              <li [ngClass]="{ active: router.url.includes('pickups-comparisation') }"
                *ngIf="authService.credentials?.user?.services?.includes('A-105')">
                <a [routerLink]="['/livraison/pickups-comparisation']">
                  Comparaison périodique
                </a>
              </li>
            </ul>
          </li> -->
          <li class="menu" *ngIf="
              authService.credentials?.user?.userType != 'User' &&
              authService.credentials?.user?.services?.includes('2')
            ">
            <a href="#PickupSubmenuPick" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
              <div class="">
                <span> Pickups</span>
              </div>
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="feather feather-chevron-right">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </div>
            </a>
            <ul class="collapse submenu list-unstyled" id="PickupSubmenuPick" data-parent="#accordionExample">
              <li [ngClass]="{ active: router.url.includes('pickups?service=2') }"
                *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/pickups']"> Manager </a>
              </li>
              <li [ngClass]="{
                  active: router.url.includes('pickups/business')
                }" *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/pickups/business']">
                  Pickups Par Expéditeur
                </a>
              </li>
              <li [ngClass]="{
                  active: router.url.includes('pickups/map')
                }" *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/pickups/map']">
                  Pickups Map
                </a>
              </li>
              <!-- <li
                class="d-flex"
                [ngClass]="{ active: router.url.includes('pickups/supplier') }"
                *ngIf="authService.credentials?.user?.services?.includes('2')"
              >
                <a [routerLink]="['/pickups/supplier']"> Pickups </a>

                <img
                  src="./../../../assets/img/services/star.png"
                  height="20"
                  class="my-auto"
                  alt=""
                />
              </li> -->
              <!-- <li
              [ngClass]="{
                active: router.url.includes('manageDelivery/fromMap/pickUp')
              }"
              *ngIf="authService.credentials?.user?.services?.includes('2')"
            >
              <a [routerLink]="['/manageDelivery/fromMap/pickUp']">
                pickup Map
              </a>
            </li> -->
            </ul>
          </li>
          <!-- <li class="menu" *ngIf="
              authService.credentials?.user?.userType != 'User' &&
              authService.credentials?.user?.services?.includes('2')
            ">
            <a href="#transferCentral" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
              <div class="">
                <span> Transfert</span>
              </div>
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="feather feather-chevron-right">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </div>
            </a>
            <ul class="collapse submenu list-unstyled" id="transferCentral" data-parent="#accordionExample">
              <li [ngClass]="{
                  active: router.url.includes('centralTransfer/list')
                }" *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/centralTransfer/list']"> list </a>
              </li>
            </ul>
          </li> -->
          <li class="menu" *ngIf="
              authService.credentials?.user?.userType != 'User' &&
              authService.credentials?.user?.services?.includes('2')
            ">
            <a href="#scan" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
              <div class="">
                <span> Scan </span>
              </div>
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="feather feather-chevron-right">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </div>
            </a>
            <ul class="collapse submenu list-unstyled" id="scan" data-parent="#accordionExample">
              <!-- <li [ngClass]="{ active: router.url.includes('/livraison/scanner/affectation') }"
                *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/scanner/affectation']">
                  Livraison
                </a>
              </li> -->
              <!-- <li [ngClass]="{ active: router.url.includes('/livraison/scanner/relance') }"
                *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/scanner/relance']">
                  Relance
                </a>
              </li> -->
              <!-- <li [ngClass]="{
                  active: router.url == '/livraison/scanner/entree-centrale'
                }" *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/scanner/entree-centrale']">
                  Entree centrale
                </a>
              </li> -->
              <!-- <li [ngClass]="{
                  active: router.url.includes('entree-centrale-offline')
                }" *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/scanner/entree-centrale-offline']">
                  Entree centrale offline
                </a>
              </li> -->
              <!-- <li [ngClass]="{
                  active: router.url.includes('entree-transfer-exchange')
                }" *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/scanner/entree-transfer-exchange']">
                  Transfert échange
                </a>
              </li> -->
              <!-- <li [ngClass]="{
                  active: router.url.includes('final-return-exchange')
                }" *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/scanner/final-return-exchange']">
                  Retour definitif échange
                </a>
              </li> -->
              <!-- <li [ngClass]="{
                  active: router.url.includes('vendor-return-exchange')
                }" *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/scanner/vendor-return-exchange']">
                  Retour vendeur échange
                </a>
              </li> -->
              <!-- <li [ngClass]="{ active: router.url.includes('reset-deliveries') }"
                *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/scanner/reset-deliveries']">
                  Résiliation des Colis
                </a>
              </li> -->
              <!-- <li
                [ngClass]="{ active: router.url.includes('verification') && !router.url.includes('verification-relance') && !router.url.includes('/livraison/scanner/verification-Hold') }"
                *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/scanner/verification']">
                  Vérification
                </a>
              </li> -->
              <!-- <li [ngClass]="{ active: router.url.includes('Hold')}"
                *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/scanner/verification-Hold']">
                  ON Hold
                </a>
              </li> -->
              <!-- <li [ngClass]="{ active: router.url.includes('verification-relance') }"
                *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/scanner/verification-relance']">
                  Verification - Relance
                </a>
              </li> -->

              <!-- <li
                [ngClass]="{ active: router.url.includes('retour-vendeur') && !router.url.includes('retour-vendeur-done') }"
                *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/scanner/retour-vendeur']">
                  Retour vendeur
                </a>
              </li> -->
              <!-- <li [ngClass]="{ active: router.url.includes('retour-vendeur-done') }"
                *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/scanner/retour-vendeur-done']">
                  Retour vendeur done
                </a>
              </li> -->
              <!-- <li [ngClass]="{
                  active: router.url.includes('transfer-centrale') && !router.url.includes('transfer-centrale-v2')
                }" *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/scanner/transfer-centrale']">
                  Transfert centrale
                </a>
              </li> -->
              <!-- <li [ngClass]="{
                  active: router.url.includes('transfer-centrale-v2')
                }" *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/scanner/transfer-centrale-v2']">
                  Transfert Automatique
                </a>
              </li> -->
              <!-- <li [ngClass]="{
                  active: router.url.includes('retour-centrale-pickup')
                }" *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/scanner/retour-centrale-pickup']">
                  Transfert retour
                </a>
              </li> -->
              <!-- <li [ngClass]="{
                active: router.url.includes('transfer-retour-auto')
              }" *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/scanner/transfer-retour-auto']">
                  Transfert retour Automatique
                </a>
              </li> -->
              <!-- <li [ngClass]="{ active: router.url.includes('retour-definitif') }"
                *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/scanner/retour-definitif']">
                  Retourner définitif
                </a>
              </li> -->
              <!-- <li [ngClass]="{ active: router.url.includes('/livraison/scanner/inventory') }">
                <a [routerLink]="['/livraison/scanner/inventory']">
                  Inventaire
                </a>
              </li> -->
              <!-- <li [ngClass]="{ active: router.url.includes('scan-histo') }"
                *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/scanner/scan-histo']">
                  Historique
                </a>
              </li> -->
              <!-- <li [ngClass]="{ active: router.url.includes('modifSize') }"
                *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/scanner/modifSize']">
                  Modifier Taille
                </a>
              </li> -->

              <!-- <li [ngClass]="{ active: router.url.includes('scanLargeSize') }"
                *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/scanner/scanLargeSize']">
                  Grande Taille
                </a>
              </li> -->
            </ul>
          </li>

          <!-- <li class="menu" *ngIf="
              authService.credentials?.user?.services?.includes('A-600')
            ">
            <a href="#self-service" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
              <div class="">
                <span> Self Service </span>
              </div>
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="feather feather-chevron-right">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </div>
            </a>
            <ul class="collapse submenu list-unstyled" id="self-service" data-parent="#accordionExample">
              <li [ngClass]="{ active: router.url.includes('/livraison/scanner/self-dispatch') }"
                *ngIf="authService.credentials?.user?.services?.includes('A-601')">
                <a [routerLink]="['/livraison/scanner/self-dispatch']">
                  Dispatch livreur
                </a>
              </li>
            </ul>
          </li> -->

          <li class="menu" *ngIf="authService.credentials?.user?.services?.includes('A-200')">
            <a href="#PartnerSubmenuPackages" data-toggle="collapse" aria-expanded="false"
              class="dropdown-toggle collapsed">
              <div class="">
                <span>Emballage</span>
              </div>
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="feather feather-chevron-right">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </div>
            </a>
            <ul class="collapse submenu list-unstyled" id="PartnerSubmenuPackages" data-parent="#accordionExample">
              <li [ngClass]="{
              active: router.url == '/packages/requests'
              }" *ngIf="authService.credentials?.user?.services?.includes('A-201')">
                <a [routerLink]="['/packages/requests']">
                  Demandes
                </a>
              </li>
            </ul>
          </li>


          <li class="menu" *ngIf="
              authService.credentials?.user?.userType != 'User' &&
              authService.credentials?.user?.services?.includes('2')
            ">
            <a href="#PartnerSubmenuPick" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
              <div class="">
                <span>Expéditeurs</span>
              </div>
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="feather feather-chevron-right">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </div>
            </a>
            <ul class="collapse submenu list-unstyled" id="PartnerSubmenuPick" data-parent="#accordionExample">
              <!-- <li [ngClass]="{ active: router.url == '/partner' }"
                *ngIf="authService.credentials?.user?.services?.includes('27')">
                <a [routerLink]="['/partner']"> Export </a>
              </li> -->
              <li [ngClass]="{ active: router.url == '/partner/lostClients' }"
                *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/partner/lostClients']"> Expéditeurs perdus </a>
              </li>
              <li [ngClass]="{ active: router.url == '/partner/delivery_min_price' }"
                *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/partner/delivery_min_price']"> Prix minimum de colis </a>
              </li>
              <li [ngClass]="{ active: router.url == '/partner/sms_access' }"
                *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/partner/sms_access']"> Accées SMS </a>
              </li>
              <li [ngClass]="{ active: router.url == '/partner/pickup-addresses' }"
                *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/partner/pickup-addresses']"> Adresses de Pickup </a>
              </li>
            </ul>
          </li>
          <li class="menu" *ngIf="
              0 &&
              authService.credentials?.user?.userType != 'User' &&
              authService.credentials?.user?.services?.includes('6')
            ">
            <a href="#financeSubmenuPick" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
              <div class="">
                <span> Finance</span>
              </div>
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="feather feather-chevron-right">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </div>
            </a>
            <ul *ngIf="authService.credentials?.user?.services?.includes('6')" class="collapse submenu list-unstyled"
              id="financeSubmenuPick" data-parent="#accordionExample">
              <li [ngClass]="{
                  active: router.url.includes('livraison/finance/etatJournal')
                }" *ngIf="authService.credentials?.user?.services?.includes('6')">
                <a [routerLink]="['/livraison/finance/etatJournal']">
                  Etat Journal
                </a>
              </li>
              <li [ngClass]="{
                  active: router.url.includes(
                    '/finance/requestPayment/listOfRequest'
                  )
                }" *ngIf="authService.credentials?.user?.services?.includes('6')">
                <a [routerLink]="['/finance/requestPayment/listOfRequest']">
                  Demande de paiement
                </a>
              </li>
              <li [ngClass]="{
                  active: router.url == '/finance/manageBusiness'
                }" *ngIf="authService.credentials?.user?.services?.includes('6')">
                <a [routerLink]="['/finance/manageBusiness']">
                  manage Business
                </a>
              </li>
              <li [ngClass]="{
                  active: router.url.includes(
                    '/finance/manageBusiness/globalStats'
                  )
                }" *ngIf="authService.credentials?.user?.services?.includes('6')">
                <a [routerLink]="['/finance/manageBusiness/globalStats']">
                  Global Stats
                </a>
              </li>

              <li [ngClass]="{ active: router.url == '/finance/encaissement' }">
                <a [routerLink]="['/finance/encaissement']"> Encaissement </a>
              </li>
              <li [ngClass]="{ active: router.url == '/finance/decaissement' }">
                <a [routerLink]="['/finance/decaissement']"> Decaissement </a>
              </li>

              <li [ngClass]="{ active: router.url == '/finance/nonCollecte' }">
                <a [routerLink]="['/finance/nonCollecte']">
                  Argent à récupérer depuis chauffeur
                </a>
              </li>
              <li [ngClass]="{ active: router.url == '/finance/collecte' }">
                <a [routerLink]="['/finance/collecte']">
                  Argent recuperé depuis chauffeur
                </a>
              </li>
              <li [ngClass]="{ active: router.url.includes('livraison/drivers') }"
                *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a [routerLink]="['/livraison/drivers']">B3-Livraison par chaufeurs</a>
              </li>
            </ul>
          </li>

          <li class="menu" *ngIf="
          0 &&
              authService.credentials?.user?.userType != 'User' &&
              authService.credentials?.user?.services?.includes('7')
            ">
            <a href="#MobileAppSubmenuPick" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
              <div class="">
                <span> App Mobile</span>
              </div>
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="feather feather-chevron-right">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </div>
            </a>
            <ul *ngIf="authService.credentials?.user?.services?.includes('7')" class="collapse submenu list-unstyled"
              id="MobileAppSubmenuPick" data-parent="#accordionExample">
              <li [ngClass]="{ active: router.url == '/mobileApp/appVersion' }">
                <a [routerLink]="['/mobileApp/appVersion']"> App versions </a>
              </li>

              <li [ngClass]="{ active: router.url == '/mobileApp/smsText' }">
                <a [routerLink]="['/mobileApp/smsText']"> SMS text </a>
              </li>
            </ul>
          </li>

          <li class="menu" *ngIf="
          0 &&
              authService.credentials?.user?.userType != 'User' &&
              authService.credentials?.user?.services?.includes('2')
            ">
            <a href="#driverScanfromadmin" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
              <div class="">
                <span>Scan drivers</span>
              </div>
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="feather feather-chevron-right">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </div>
            </a>
            <ul class="collapse submenu list-unstyled" id="driverScanfromadmin" data-parent="#accordionExample">
              <li [ngClass]="{
                  active: router.url.includes('drivers/scan-transfer')
                }" *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a target="_blank" [routerLink]="['/drivers/scan-transfer']">
                  scan transfer
                </a>
              </li>
              <li [ngClass]="{
                  active: router.url.includes('drivers/scan-transfer')
                }" *ngIf="authService.credentials?.user?.services?.includes('2')">
                <a target="_blank" [routerLink]="['/drivers/scan-pickup']">
                  scan pickup
                </a>
              </li>
            </ul>
          </li>
          <li class="menu" *ngIf="
          0 &&
              authService.credentials?.user?.userType != 'User' &&
              authService.credentials?.user?.services?.includes('2')
            ">
            <a href="#dataCleaningSubmenuPick" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
              <div class="">
                <span>Data cleaning</span>
              </div>
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="feather feather-chevron-right">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </div>
            </a>
            <ul *ngIf="authService.credentials?.user?.services?.includes('2')" class="collapse submenu list-unstyled"
              id="dataCleaningSubmenuPick" data-parent="#accordionExample">
              <li [ngClass]="{ active: router.url == '/livraison/cleanData' }">
                <a [routerLink]="['/livraison/cleanData']">
                  Livraison & PickUp
                </a>
              </li>
            </ul>
          </li>

          <!--<li
          class="menu"
          *ngIf="
            authService.credentials?.user?.userType != 'User' &&
            authService.credentials?.user?.services.includes('1')
          "
        >
          <a
            href="#submenu"
            data-toggle="collapse"
            aria-expanded="false"
            class="dropdown-toggle"
          >
            <div class="">
              <span> Conciergerie</span>
            </div>
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-chevron-right"
              >
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </div>
          </a>
          <ul
            class="collapse submenu list-unstyled"
            id="submenu"
            data-parent="#accordionExample"
          >
            <li
              [ngClass]="{ active: router.url.includes('Conciergerie/list') }"
              *ngIf="authService.credentials?.user?.services.includes('1')"
            >
              <a [routerLink]="['/manageConciergerie/list']"> Requests </a>
            </li>
            <li
              [ngClass]="{ active: router.url.includes('Conciergerie/schedule') }"
              *ngIf="authService.credentials?.user?.services.includes('1')"
            >
              <a [routerLink]="['/manageConciergerie/schedule']"> Schedule </a>
            </li>
          </ul>
        </li>-->
          <li class="menu" *ngIf="
              authService.credentials?.user?.userType == 'Admin' &&
              authService.credentials?.user?.services.includes('5')
            ">
            <a href="#adminUsers" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
              <div class="">
                <span> {{ "USERS.TITLE" | translate }}</span>
              </div>
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="feather feather-chevron-right">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </div>
            </a>
            <ul class="collapse submenu list-unstyled" id="adminUsers" data-parent="#accordionExample">
              <li [ngClass]="{ active: router.url.includes('/users/list/User') }"
                *ngIf="authService.credentials?.user?.services.includes('A-100')">
                <a [routerLink]="['/users/list/User']"> User </a>
              </li>
              <!-- <li [ngClass]="{ active: router.url.includes('/users/list/Driver') }"
                *ngIf="authService.credentials?.user?.services.includes('5')">
                <a [routerLink]="['/users/list/Driver']"> Driver </a>
              </li> -->
              <li [ngClass]="{ active: router.url.includes('/users/list/Admin') }"
                *ngIf="authService.credentials?.user?.services.includes('5')">
                <a [routerLink]="['/users/list/Admin']"> Admin </a>
              </li>
              <!-- <li
                [ngClass]="{
                  active: router.url.includes('/creditTransactions')
                }"
                *ngIf="authService.credentials?.user?.services.includes('5')"
              >
                <a [routerLink]="['/payment/creditTransactions']">
                  {{ "SIDENAV.CREDIT_TRANSACTION" | translate }}
                </a>
              </li> -->
              <li [ngClass]="{ active: router.url.includes('/centrales') }"
                *ngIf="authService.credentials?.user?.services.includes('5')">
                <a [routerLink]="['/users/centrales']"> Centrales </a>
              </li>
            </ul>
          </li>
          <li class="menu" *ngIf="
          authService.credentials?.user?.userType == 'Admin' &&
          authService.credentials?.user?.services.includes('5')
        ">
            <a href="#params" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
              <div class="">
                <span> {{ "PARAMS.TITLE" | translate }}</span>
              </div>
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="feather feather-chevron-right">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </div>
            </a>
            <ul class="collapse submenu list-unstyled" id="params" data-parent="#accordionExample">
              <li [ngClass]="{ active: router.url.includes('/params/messages') }"
                *ngIf="authService.credentials?.user?.services.includes('5')">
                <a [routerLink]="['/params/messages']"> Messages </a>
              </li>
              <li [ngClass]="{ active: router.url.includes('/params/alerts') }"
                *ngIf="authService.credentials?.user?.services.includes('5')">
                <a [routerLink]="['/params/alerts']"> Alerts </a>
              </li>
            </ul>
          </li>
          <li class="menu" *ngIf="0&&
              authService.credentials?.user?.userType == 'Admin' &&
              authService.credentials?.user?.services.includes('8')
            ">
            <a href="#ChartStats" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
              <div class="">
                <span>Statistics</span>
              </div>
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="feather feather-chevron-right">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </div>
            </a>
            <ul class="collapse submenu list-unstyled" id="ChartStats" data-parent="#accordionExample">
              <li [ngClass]="{
                  active: router.url.includes == '/dashboard/dailyreports'
                }" *ngIf="authService.credentials?.user?.services.includes('8')">
                <a [routerLink]="['/dashboard/dailyreports']">
                  Rapports livreurs
                </a>
              </li>
              <li [ngClass]="{
                  active: router.url.includes == '/dashboard/leaderBoard'
                }" *ngIf="authService.credentials?.user?.services.includes('8')">
                <a [routerLink]="['/dashboard/leaderBoard']"> LeaderBoard </a>
              </li>
              <li [ngClass]="{ active: router.url.includes == '/dashboard' }"
                *ngIf="authService.credentials?.user?.services.includes('8')">
                <a [routerLink]="['/dashboard']"> Dashboard </a>
              </li>

              <li [ngClass]="{
                  active: router.url.includes('/dashboard/business')
                }" *ngIf="authService.credentials?.user?.services.includes('8')">
                <a [routerLink]="['/dashboard/business']"> Business </a>
              </li>

              <li [ngClass]="{
                  active: router.url.includes('/dashboard/transfert')
                }" *ngIf="authService.credentials?.user?.services.includes('8')">
                <a [routerLink]="['/dashboard/transfert']"> Centrale View </a>
              </li>

              <li [ngClass]="{ active: router.url.includes('/dashboard/admin') }"
                *ngIf="authService.credentials?.user?.services.includes('8')">
                <a href="#sm23" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
                  Admin
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="feather feather-chevron-right">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </a>
                <ul class="collapse list-unstyled sub-submenu" id="sm23" data-parent="#ChartStats">
                  <li [ngClass]="{
                      active:
                        router.url.includes('analyticsType=0') &&
                        router.url.includes('/dashboard/admin')
                    }">
                    <a [routerLink]="['/dashboard/admin']" [queryParams]="{ analyticsType: '0' }">
                      generale</a>
                  </li>
                  <li [ngClass]="{
                      active:
                        router.url.includes('analyticsType=1') &&
                        router.url.includes('/dashboard/admin')
                    }">
                    <a [routerLink]="['/dashboard/admin']" [queryParams]="{ analyticsType: '1' }">
                      pickups</a>
                  </li>
                  <li [ngClass]="{
                      active:
                        router.url.includes('analyticsType=2') &&
                        router.url.includes('/dashboard/admin')
                    }">
                    <a [routerLink]="['/dashboard/admin']" [queryParams]="{ analyticsType: '2' }">
                      livraison
                    </a>
                  </li>
                </ul>
              </li>

              <li [ngClass]="{ active: router.url.includes('/dashboard/driver') }">
                <a href="#sm22" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
                  Driver
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="feather feather-chevron-right">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </a>
                <ul class="collapse list-unstyled sub-submenu" id="sm22" data-parent="#ChartStats">
                  <li [ngClass]="{
                      active: router.url.includes('analyticsType=1')
                    }">
                    <a [routerLink]="['/dashboard/driver']" [queryParams]="{ analyticsType: '1' }">
                      pickups</a>
                  </li>
                  <li [ngClass]="{
                      active: router.url.includes('analyticsType=2')
                    }">
                    <a [routerLink]="['/dashboard/driver']" [queryParams]="{ analyticsType: '2' }">
                      livraison
                    </a>
                  </li>
                  <li [ngClass]="{
                      active: router.url.includes('dashboard/driver-calls')
                    }">
                    <a [routerLink]="['/dashboard/driver-calls']"> calls </a>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</div>

<div *ngIf="user?.userType == 'User'" class="btn-add d-md-none d-lg-none">
  <a [routerLink]="['/business/livraison/add']">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#000000" stroke="currentColor" stroke-width="2"
      stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus">
      <line _ngcontent-ckc-c232="" x1="12" y1="5" x2="12" y2="19"></line>
      <line _ngcontent-ckc-c232="" x1="5" y1="12" x2="19" y2="12"></line>
    </svg>
  </a>
</div>